import React from 'react';
import { getCalendarSettings } from 'constants/calendarSettings';

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.shape Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @param {string} [props.fieldClassName] CSS class used by each input label.
 * @returns {React.ReactElement}
 */
const DaySpacingFields = ({ shape, onChange, fieldClassName }) => {
  const { margin, padding } = getCalendarSettings(shape).DayShape;
  /** @type {{field: 'dayMargin'|'dayPadding', label: string, values: import('constants/calendarSettings').Margin}[]} */
  const groups = [
    { field: 'dayMargin', label: 'Margin', values: margin },
    { field: 'dayPadding', label: 'Padding', values: padding },
  ];
  /** @type {(keyof import('constants/calendarSettings').Margin)[]} */
  const sides = ['left', 'right', 'top', 'bottom'];

  return (
    <>
      {groups.map(({ field, label, values }) => (
        <div key={field}>
          <strong>{label}</strong>
          {sides.map((side) => (
            <label key={side} className={fieldClassName}>
              <span>{side.charAt(0).toUpperCase() + side.slice(1)}</span>
              <input
                type="number"
                min="0"
                step="any"
                aria-label={`Day ${label.toLowerCase()} ${side}`}
                value={values[side]}
                onChange={(event) => {
                  const value = Number(event.target.value);
                  onChange({
                    calendarShapeSize: { [field]: { [side]: Number.isFinite(value) ? Math.max(0, value) : 0 } },
                  });
                }}
              />
            </label>
          ))}
        </div>
      ))}
    </>
  );
};

export default DaySpacingFields;
